import { useEffect } from 'react';
import { simpleBodyScrollLock } from '../../../helpers/bodyScrollLock';
import useMediaQuery from '../../../hooks/useMediaQuery';

function useSimpleBodyScrollLock(shouldLock: boolean): void {
  const { isSmall } = useMediaQuery();

  useEffect(() => {
    simpleBodyScrollLock(isSmall && shouldLock);
  }, [isSmall, shouldLock]);
}

export default useSimpleBodyScrollLock;
